import { createDialogWithIdStore } from 'store/createDialogWithIdStore';
import { Opportunity } from 'types/savings';

export const useOpportunityAutomationDialog = createDialogWithIdStore<Opportunity[]>();
